import { Injectable, signal } from '@angular/core';
import { FlowManagementService } from './flow-management.service';
//import { AdalService } from 'ng2-adal/dist/core';
import { BehaviorSubject, Observable, firstValueFrom } from 'rxjs';
import { DialogService, DialogRef, DialogCloseResult } from '@progress/kendo-angular-dialog';
import { environment } from '../../environments/environment';
import * as constants from '../constants';
// import { Settings } from '../flows/settings';
// import { StorageDexieService } from './storage.service';
import { FlowEventService } from './flow-event.service';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
// import { MsalService } from '@azure/msal-angular';
import { MsalHelperService } from './msal-helper.service';
import { map, tap } from 'rxjs/operators';
import { Angulartics2GoogleTagManager } from 'angulartics2';
import { Setting } from '../obj/Setting';
// import { StorageDexieService } from './storage.service';
// import { Settings } from '../flows/settings';

//import { query, refreshQuery, setQueryConfig } from 'rx-query';


export const LAST_SUB = '2018-11-19';

@Injectable({
  providedIn: 'root'
})
export class PaymentService {

  userId: string;
  membership: any = {
    "status": "",
    "created": "",
    "trialEnd": ""
  };

  private subscriptionSetting: Setting<any>;
  membership$ = new BehaviorSubject(this.membership);
  public portal$ = new BehaviorSubject('');
  public licenses$ = new BehaviorSubject([]);

  public licenseHasTeams$: Observable<boolean> = this.licenses$.pipe(map((licenses)=>{
    const [license] = licenses.filter((l)=>l.license_teams);
    return !!license
  }));
  public subscription$ = new BehaviorSubject<ISubscription>(null);
  public workspace = signal<IWorkspace[] | null>(null);

  // free_remain: number = 0;
  // free_reset: string = '';
  constructor(
    private msalHelperService: MsalHelperService,
    private flowManagementService: FlowManagementService,
    private dialogService: DialogService,
    private flowEventService: FlowEventService,
    private gtm: Angulartics2GoogleTagManager
    /*private storageDexieService: StorageDexieService*/) {

      this.subscriptionSetting = new Setting<any>(
        () => this.subscriptionCacheKey(),
        environment.production ? 30 : 0,
        async ()=>{
          if (this.msalHelperService.getUser()) {
            try {
              return await firstValueFrom(this.flowManagementService.getSubscription(true));
            } catch (e) {
              console.warn('[DEBUG] payment.service.ts: firstValueFrom(getSubscription) threw:', e);
              return null;
            }
          }
          else {
            return null;
          }
        },
        (subscription) => this.isSubscriptionForCurrentUser(subscription),
      );

      // setQueryConfig({
      //   keepPreviousData: true,
      //   staleTime: 1000*60*5,
      //   cacheTime: 1000*60*5
      // });

      Promise.all([this.subscriptionSetting.value()])
      .then(([subscription])=>{
        this.handleSubscriptionValue(subscription);
      });
  }

  private subscriptionCacheKey(): string {
    const username = (this.msalHelperService.getUser()?.username || 'anonymous').toLowerCase();
    const prefix = environment.production ? 'fs_s' : 'fs_s_dev';
    return `${prefix}_${username}`;
  }

  private isSubscriptionForCurrentUser(subscription: any): boolean {
    const username = this.msalHelperService.getUser()?.username?.toLowerCase();
    const subscriptionUser = subscription?.userId?.toLowerCase();
    return !username || !subscriptionUser || username === subscriptionUser;
  }
  
  public handleSubscriptionValue(subscription){
    //debugger;
    // if (user == null) {
    //   return;
    // }

    // const subscription = output.data;
    if (!subscription) {
      return;
    }

    this.userId = subscription.userId;
    this.membership = subscription.membership;

    this.gtm.pushLayer({
      'membership': this.membership?.status
    });

    if (subscription.flags && subscription.flags.portal) {
      this.portal$.next(subscription.flags.portal);
    }

    this.membership$.next(this.membership);
    if (subscription.licenses && subscription.licenses.length > 0) {
      this.licenses$.next(subscription.licenses);
    }
    this.subscription$.next(subscription);
    this.workspace.set(subscription.workspace ?? null);
  }

  public async verify(get = false, force = false) {

    // this.userId = this.adalService.userInfo.userName;
    // this.membership = {
    //   "status": "Trial"
    // };


    // let pFree = this.storageDexieService.getSettings().then(settings=>{
    //   if (settings[Settings.SETTING_FREE_REMAIN] != null) {
    //     this.free_remain = settings[Settings.SETTING_FREE_REMAIN].value || 0;
    //   }
    //   if (settings[Settings.SETTING_FREE_RESET] != null) {
    //     this.free_reset = settings[Settings.SETTING_FREE_RESET].value || 0;
    //   }
    // });

    if (force) {
      this.subscriptionSetting.clear();
      return this.subscriptionSetting.value().then((subscription)=>{
        this.handleSubscriptionValue(subscription);

        return subscription;
      });  
    }
    else {
      return this.subscriptionSetting.value();
    }

    //return lastValueFrom(this.membership$);
  }

  public async processPayment(token: string, product: string, coupon = null) {
    // refreshQuery(`subscription-get`);
    this.subscriptionSetting.clear();

    const subscription = await this.flowManagementService.updateSubscription(token, product, coupon);
    if (subscription.error) {
      // display error
    }
    this.userId = subscription.userId;
    this.membership = subscription.membership;
    this.membership$.next(this.membership);
  }

  public checkout(plan: 'pro' | 'teams', yearly = false) {
    this.verify(true, true);

    let product: string;
    let amount: number;
    let description: string;

    if (plan === 'teams') {
      product = yearly ? 'Teams-Yearly' : 'Teams-Monthly';
      amount = (yearly ? constants.teams_yearly : constants.teams_monthly) * 100;
      description = yearly
        ? `Yearly Subscription US$${constants.teams_yearly} / Year`
        : `Monthly Subscription US$${constants.teams_monthly} / Month`;
    } else {
      product = yearly ? 'Yearly' : 'Monthly';
      amount = (yearly ? constants.pro_yearly : constants.pro_monthly) * 100;
      description = yearly
        ? `Yearly Subscription US$${constants.pro_yearly} / Year`
        : `Monthly Subscription US$${constants.pro_monthly} / Month`;
    }

    const handler = (<any>window).StripeCheckout.configure({
      key: environment.stripeKey,
      locale: 'auto',
      token: (token) => {
        this.gtm.pushLayer({
          'event': 'purchase',
          'currency': 'USD',
          'value': amount,
          'transaction_id': `${token.id}`,
          'items': [{ 'item_name': product }]
        });
        this.processPayment(token, product);
      }
    });

    this.gtm.pushLayer({
      'event': 'begin_checkout',
      'currency': 'USD',
      'value': amount,
      'items': [{ 'item_name': product }]
    });

    handler.open({
      email: this.userId,
      name: 'FlowStudio',
      image: '/assets/flow-studio-logo-90.png',
      zipCode: true,
      description,
      amount
    });
  }

  public async updateUsers(workspace: string, users: any[], join = false) {

    return this.flowManagementService.updateUsers(workspace, users, join);
  }

  public async checkSubscription1(): Promise<boolean> {

    var status = await new Promise<boolean>((resolve, reject)=>{
      if (this.membership.status != "") {
        resolve(this.membership.status == "Trial" || this.membership.status == "Active" || this.membership.status == "Enterprise");
      }
      else {
        this.verify().then(()=>{
          resolve(this.membership.status == "Trial" || this.membership.status == "Active" || this.membership.status == "Enterprise");
        }).catch(reject);
      }
    })

    if (status) {
      return true;
    }

    const dialog: DialogRef = this.dialogService.open({
        title: 'FlowStudio Subscription Feature',
        content: 'This is a subscription feature, would you like to review FlowStudio subscriptions?',
        actions: [
            { text: 'Yes', primary: true },
            { text: 'No' }
        ],
        width: 450,
        height: 200,
        minWidth: 250
    });
    var openSubscription = await dialog.result.toPromise().then((result:any) => {
        return result.text == 'Yes';
    });

    if (openSubscription) {
      this.flowEventService.showSubscription$.next(true);
    }

    return false;

  }

  public async checkSubscription(silent = false) : Promise<boolean> {

    var status = await new Promise<boolean>((resolve, reject)=>{
      if (this.membership.status !== "") {
        resolve(["Trial", "Active", "Enterprise"].includes(this.membership.status));
      }
      else {
        // resolve(false);
        this.verify().then((subscription)=>{
           resolve(["Trial", "Active", "Enterprise"].includes(subscription?.membership?.status));
        }).catch(reject);
      }
    })

    if (status) {
      return true;
    }
    if (silent) {
      return false;
    }

    const dialog: DialogRef = this.dialogService.open({
        title: 'FlowStudio Subscription Feature',
        content: 'This is a subscription feature, would you like to review subscriptions options?',
        actions: [
            { text: 'Yes', primary: true },
            { text: 'No' }
        ],
        width: 450,
        height: 200,
        minWidth: 250
    });
    var openSubscription = await dialog.result.toPromise().then((result:any) => {
        return result.text == 'Yes';
    });

    if (openSubscription) {
      this.flowEventService.showSubscription$.next(true);
    }

    return false;
  }
}

export interface ISubscription {
  workspace?: IWorkspace[];
  users?: IUser[]
}

export interface IWorkspace {
  title: string;
  customer: string;  
  seats_pro: number;
  seats_teams: number;
  flow_capacity: number;
  domains: string;
}

export interface IUser {
  workspace: string;
  user_type: string;
  license_teams?: string;
  license_teams_assigned?: string | null; // ISO date string
  license_pro?: string | null;
  license_pro_assigned?: string | null; // ISO date string
  title: string;
  invitation: string;
}


@Injectable()
export class SubscriptionGuard  {
  constructor(
    private paymentService: PaymentService,
    private router: Router) {

  }

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    // console.log(route);
    // console.log(state);

    var status = await this.paymentService.checkSubscription();

    if (!status) {
      this.router.navigate(['/flows']);
    }
    return status;
  }
}


